<template>
  <el-dialog
    title="是否操作马帮出库"
    :visible.sync="visible"
    width="420px"
    custom-class="box-help-dialog"
  >
    <p class="outbound-tip">装箱清单已下载到本地。是否继续执行马帮出库操作？</p>
    <span slot="footer">
      <el-button @click="close">暂不出库</el-button>
      <el-button type="success" @click="confirm">马帮出库</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "OutboundConfirmDialog",
  data() {
    return {
      // 弹窗显示状态。
      visible: false,
      // 当前待执行马帮出库的装箱单号。
      packingNo: "",
      // 当前待执行马帮出库的主单版本。
      version: 0,
    };
  },
  methods: {
    // 供父组件通过 $refs 调用，打开弹窗并记录装箱单号。
    open: function (payload) {
      // 父组件传入的出库上下文。
      const context = typeof payload === "object" ? payload : { packingNo: payload };
      this.packingNo = context.packingNo || context.packCode || "";
      this.version = context.version || 0;
      this.visible = true;
    },
    // 关闭弹窗并清空当前装箱单号。
    close: function () {
      this.visible = false;
      this.packingNo = "";
      this.version = 0;
    },
    // 确认马帮出库，将装箱单号回传给父组件执行。
    confirm: function () {
      this.$emit("confirm", {
        packingNo: this.packingNo,
        version: this.version,
      });
      this.close();
    },
  },
};
</script>

<style scoped>
.outbound-tip {
  margin-bottom: 18px;
  color: #8c939d;
  line-height: 1.5;
}
</style>
